module.exports = "{{name}}\n"